import { render } from "./AdminStatistics.vue?vue&type=template&id=3f869521&scoped=true"
import script from "./AdminStatistics.vue?vue&type=script&lang=js"
export * from "./AdminStatistics.vue?vue&type=script&lang=js"

import "./AdminStatistics.vue?vue&type=style&index=0&id=3f869521&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f869521"]])

export default __exports__